import { render, staticRenderFns } from "./unloadDetail.vue?vue&type=template&id=a0f7678c&"
import script from "./unloadDetail.vue?vue&type=script&lang=js&"
export * from "./unloadDetail.vue?vue&type=script&lang=js&"
import style0 from "./unloadDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports